import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "@env";
import {
  PartCategoryDriveBDTO,
  PartCategoryDTO,
  PartCategoryPartsApiDTO,
  PartCategorySimplifiedDTO
} from "@shared/models/part-category-dto";
import { currencyUser } from "@shared/components/currencyUser/currencyUser";
import { KeycloakHelperService } from "./keycloak.helper.service";

@Injectable({
  providedIn: "root"
})
export class PartCategoryService {
  private partCategoryUrl = "part-category";
  private partCategoryPartFormUrl = "part-category/get-by-locale";
  private partCategoriesUrl = "part-categories"

  constructor(
    private http: HttpClient,
    private keycloakHelperService: KeycloakHelperService
  ) {}

  save(partCategoryDTO: {
    portugueseName: string;
    englishName: string;
    spanishName: string;
    germanName: string;
  }): Observable<any> {
    return this.http.post<any>(
      `${environment.microserviceParts}${this.partCategoryUrl}`,
      partCategoryDTO
    );
  }

  listAll(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.microserviceParts}${this.partCategoryUrl}`
    );
  }

  listAllPartsApi(): Observable<PartCategoryPartsApiDTO> {
    const currency = currencyUser(
      this.keycloakHelperService.getUserCountryCode()
    );
    const headers = new HttpHeaders({
      "Accept-Language": currency
    });
    return this.http.get<PartCategoryPartsApiDTO>(
      `${environment.microserviceParts}${this.partCategoryPartFormUrl}?categoryName=`,
      { headers }
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(
      `${environment.microserviceParts}${this.partCategoryUrl}/${id}`
    );
  }

  findById(id: number): Observable<PartCategoryDriveBDTO> {
    return this.http.get<PartCategoryDriveBDTO>(
      `${environment.microserviceParts}${this.partCategoryUrl}/${id}`
    );
  }

  edit(
    id: number,
    partCategoryDTO: {
      portugueseName: string;
      englishName: string;
      spanishName: string;
      germanName: string;
    }
  ): Observable<any> {
    return this.http.put<any>(
      `${environment.microserviceParts}${this.partCategoryUrl}/${id}`,
      partCategoryDTO
    );
  }

  findByFilters(name: string) {
    return this.http.get<PartCategorySimplifiedDTO[]>(
      `${environment.microserviceParts}${this.partCategoryPartFormUrl}?categoryName=${name}`
    );
  }

  getPartApprovalHistory(id: number) {
    return this.http.get<any[]>(
      `${environment.microserviceParts}parts/${id}/history`
    );
  }

  listPartsCategory(): Observable<PartCategoryDTO[]>{
    return this.http.get<PartCategoryDTO[]>(
      `${environment.apiUrl}${this.partCategoriesUrl}`
    );
  }
}
